import { AdminService, AuthService, UserService, XepptClient } from '@xeppt/xeppt-sdk';
import { AmlSettingsService } from './amlSettings';
import { EpsSettingsService } from './epsSettings';
import { FundsFlowService } from './fundsFlow';
export type { TAmlSettings, TAmlSettingsAuditItem, TAmlConnectionTestResult, TAmlSettingsAudit, TAmlSettingsSource } from './amlSettings';
export type { TEpsSettings, TEpsSettingsAuditItem, TEpsConnectionTestResult, TEpsSettingsAudit, TEpsSettingsSource } from './epsSettings';
export type { TFundsFlowRequest, TFundsFlowResponse, TFundsFlowCurrencyBlock, TFundsFlowKpis, TFundsFlowOpRow, TFundsFlowBucketRow, TFundsFlowBucket } from './fundsFlow';

export const sdk = new XepptClient(
    {
        baseURL: process.env.REACT_APP_BACKEND_URL
    },
    () => {
        localStorage.removeItem('client-metadata');
    }
);

export const apiAdminService = new AdminService(sdk);
export const apiAuthService = new AuthService(sdk);
export const apiUserService = new UserService(sdk);
export const apiAmlSettingsService = new AmlSettingsService(sdk);
export const apiEpsSettingsService = new EpsSettingsService(sdk);
export const apiFundsFlowService = new FundsFlowService(sdk);
